module.exports = __webpack_public_path__ + "static/media/shoot.6454848a.wav";